export enum UsageRegionReceiver {
  TARGET_COUNTRY_AUTHORITY = 'targetCountryAuthority',
  PRIVATE_OR_OTHER_OPERATOR = 'privateOrOtherOperator',
}
